<template>
  <div v-if="isVisible">
    <div class="modal" :style="dStyle" tabindex="-1" role="dialog" data-bs-backdrop="static" data-bs-keyboard="false">
      <div class="modal-dialog modal-dialog-scrollable" :class="modalSize" :style="minHeight ? { '--dt-modal-min-height': minHeight + 'px' } : null" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <slot name="header"></slot>
          </div>
          <div class="modal-body">
            <slot name="body"></slot>
          </div>
          <div class="modal-footer">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade show" :style="bdStyle"></div>
  </div>
</template>

<script>
export default {
  name: 'dt-modal',
  props: ['value', 'modalSize', 'dStyle', 'bdStyle', 'minHeight'],
  computed: {
    isVisible: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>

<style scoped>
.modal {
  display: block;
}

/* Let a scrollable modal grow up to the full browser-window height while keeping
   the top and bottom padding symmetric. Bootstrap gives the dialog a 30px top &
   bottom margin ($modal-dialog-margin-y-sm-up) but caps modal-dialog-scrollable at
   calc(100% - 20px), so a tall modal could clip 10px at the bottom. Capping both the
   dialog and its content at calc(100vh - 60px) (30px top + 30px bottom) makes a large
   modal fill the window with even padding, while a small one still shrinks to its
   content (this is only a max, not a fixed height). */
/* Optional floor: when a caller passes :min-height, it sets the --dt-modal-min-height
   custom property on the dialog, which both the dialog and its content honour. Without
   it the var falls back to 0, so every other modal keeps shrinking to its content. The
   max-height cap above still applies, and the modal-body stays scrollable. */
.modal-dialog-scrollable {
  max-height: calc(100vh - 60px);
  min-height: var(--dt-modal-min-height, 0);
}
.modal-dialog-scrollable .modal-content {
  max-height: calc(100vh - 60px);
  min-height: var(--dt-modal-min-height, 0);
}
</style>



// WEBPACK FOOTER //
// src/components/utilities/modal/dt-modal.vue